import { post } from "../core";

export const addLead = async(body) => {
    try{
        const res = await post('/leads', body);
        return res.data;
    }catch(err){
        throw err;
    }
}